angular.module('gantt.resizeSensor.templates', []).run(['$templateCache', function ($templateCache) {

}]);
